"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTypeFamilyUpsert = exports.ServiceTypeFamilyUpdate = exports.ServiceTypeFamilyCreate = exports.ServiceTypeFamily = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const CommunicationTrigger_1 = require("./CommunicationTrigger");
const ServiceLineItemType_1 = require("./ServiceLineItemType");
const common_types_1 = require("./common-types");
// Define a basic ServiceType schema directly here
const ServiceTypeInFamily = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    setupType: common_types_1.SetupType,
    active: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.ServiceTypeFamily = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    shortCode: typebox_1.Type.String({ maxLength: 2 }),
    allowedStatuses: typebox_1.Type.Array(common_types_1.ServiceOrderStatus),
    initialStatus: typebox_1.Type.Optional(common_types_1.ServiceOrderStatus),
    communicationTriggers: typebox_1.Type.Array(CommunicationTrigger_1.CommunicationTrigger),
    lineItemTypes: typebox_1.Type.Array(ServiceLineItemType_1.ServiceLineItemType),
    serviceTypes: typebox_1.Type.Array(ServiceTypeInFamily),
    isSubscription: typebox_1.Type.Boolean(),
    // This is temporary. These eventually will be moved to a dedicated notification service
    customerConfirmation: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerOrderChanges: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorOrderChanges: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.ServiceTypeFamilyCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceTypeFamily, [
        'id',
        'communicationTriggers',
        'lineItemTypes',
        'serviceTypes',
        'metadata',
        'initialStatus',
    ]),
    typebox_1.Type.Object({
        initialStatus: typebox_1.Type.Optional((0, common_1.Nullable)(common_types_1.ServiceOrderStatus)),
    }),
]);
exports.ServiceTypeFamilyUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.ServiceTypeFamily, [
        'id',
        'communicationTriggers',
        'initialStatus',
        'lineItemTypes',
        'serviceTypes',
        'metadata',
    ])),
    typebox_1.Type.Object({
        initialStatus: typebox_1.Type.Optional((0, common_1.Nullable)(common_types_1.ServiceOrderStatus)),
    }),
]);
// Define a basic ServiceTypeRecursiveUpdate schema directly here
const ServiceTypeRecursiveUpdateInner = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    setupType: typebox_1.Type.Optional(common_types_1.SetupType),
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.ServiceTypeFamilyUpsert = typebox_1.Type.Intersect([
    exports.ServiceTypeFamilyCreate,
    typebox_1.Type.Object({
        id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        communicationTriggers: typebox_1.Type.Array(CommunicationTrigger_1.CommunicationTriggerUpsert),
        serviceTypes: typebox_1.Type.Array(ServiceTypeRecursiveUpdateInner),
        lineItemTypes: typebox_1.Type.Array(ServiceLineItemType_1.ServiceLineItemTypeUpsert),
    }),
]);
//# sourceMappingURL=ServiceTypeFamily.js.map